export * from './router-data-extractor';
export * from './url-helpers';


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/utils/index.ts